import Alert from "meta/ui2/alert/Alert";
import { Container } from "meta/ui2/layout";
import api from "screens/Root/api";
import { useEffect, useState } from "react";
const SystemMessages = () => {
    const [systemMessages, setSystemMessages] = useState([]);
    const [closedMessages, setClosedMessages] = useState([]);
    const refreshInterval = 1000 * 60;
    const fetchSystemMessages = async () => {
        const { data } = await api.getSystemMessages();
        setSystemMessages(data);
    };
    const closeAlert = (id) => {
        setClosedMessages([id, ...closedMessages]);
    };
    useEffect(() => {
        fetchSystemMessages();
        var interval = window.setInterval(fetchSystemMessages, refreshInterval);
        return () => window.clearInterval(interval);
    }, []);
    return (<Container style={{ margin: "6px 11px 0px" }} column flex="0 0 auto" visible={systemMessages.length > 0}>
            {systemMessages.map((message) => {
            return closedMessages.includes(message.id)
                ? ""
                : (<Alert title={message.title ?? ""} message={message.text} type={message.type} onClose={message.isClosable ? () => closeAlert(message.id) : undefined} closable={message.isClosable} closeButtonText="DISMISS"/>);
        })}
        </Container>);
};
export default SystemMessages;
